export const consiglioNazionaleNapoli2024 = {
  id: 'static-consiglio-nazionale-napoli-2024',
  slug: 'consiglio-nazionale-napoli-2024',
  title: 'Consiglio Nazionale UNASCA 2024 - Napoli',
  excerpt: 'Il Consiglio Nazionale UNASCA 2024 si è svolto con grande successo a Napoli il 24 novembre 2024 presso il Ramada Naples City Centre. Oltre 200 partecipanti da tutta Italia.',
  body: `
    <div style="background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.05) 100%); border-left: 4px solid #ef4444; padding: 1.5rem; border-radius: 12px; margin-bottom: 2rem; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #dc2626; margin-bottom: 1rem; font-size: 1.3rem;">
        <i class="fas fa-exclamation-circle"></i> Evento Terminato
      </h3>
      <p style="margin-bottom: 1rem;">Il Consiglio Nazionale UNASCA 2024 di Napoli si è già svolto. Le informazioni in questa pagina sono mantenute a scopo di archivio.</p>
      <p style="margin-bottom: 0;">Ti invitiamo a partecipare al prossimo <strong>Consiglio Nazionale UNASCA</strong> che si terrà a <strong>Milano il 25 Maggio 2025</strong>.</p>
    </div>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.1) 0%, rgba(0, 21, 16, 0.05) 100%); border-left: 4px solid #00bf8f; padding: 1.5rem; border-radius: 12px; margin-bottom: 2rem; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #00bf8f; margin-bottom: 1rem; font-size: 1.3rem;">
        <i class="fas fa-calendar-check"></i> L'Evento in Sintesi
      </h3>
      <p style="margin-bottom: 0.5rem;"><strong>📅 Data:</strong> 24 novembre 2024</p>
      <p style="margin-bottom: 0.5rem;"><strong>📍 Sede:</strong> Ramada Naples City Centre - Via G. Ferraris, 40, Napoli</p>
      <p style="margin-bottom: 0.5rem;"><strong>⏰ Orari:</strong> 09:30 - 14:00</p>
      <p style="margin-bottom: 0;"><strong>👥 Partecipanti:</strong> Oltre 200 associati da tutta Italia</p>
    </div>

    <h2>📋 Programma del Consiglio</h2>

    <div style="background: white; border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <ol style="margin-left: 1.5rem; line-height: 2;">
        <li><strong>Relazione del Segretario Nazionale</strong></li>
        <li><strong>Rapporti con il Ministero dell'Interno</strong></li>
        <li><strong>Nuovo scenario MCTC</strong></li>
        <li><strong>Registro unico STA</strong></li>
        <li><strong>Regolamento Rete Certificata</strong></li>
        <li><strong>Comunicazioni del Segretario Nazionale</strong></li>
      </ol>
    </div>

    <h2>🏨 Sede dell'Evento</h2>

    <div style="background: white; border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #00bf8f; margin-bottom: 1rem;">
        <i class="fas fa-hotel"></i> Ramada Naples City Centre
      </h3>
      <p style="margin-bottom: 1rem;"><strong>Indirizzo:</strong> Via G. Ferraris, 40, Napoli</p>
      <p style="margin-bottom: 1.5rem;">Il Consiglio Nazionale si è svolto presso il prestigioso Ramada Naples City Centre, una location moderna e funzionale nel cuore di Napoli.</p>
      <a href="https://maps.app.goo.gl/9fKnLomCyAKAWiHGA" target="_blank" style="display: inline-block; background: #00bf8f; color: white; padding: 0.75rem 1.5rem; border-radius: 8px; text-decoration: none; font-weight: 600;">
        <i class="fas fa-directions"></i> Visualizza su Google Maps
      </a>
    </div>

    <h2>📸 Galleria Fotografica</h2>

    <p>L'evento è stato documentato con una ricca galleria fotografica che raccoglie i momenti più significativi della giornata.</p>

    <div style="background: linear-gradient(135deg, #00bf8f 0%, #001510 100%); color: white; border-radius: 12px; padding: 2.5rem; margin: 2rem 0; text-align: center; box-shadow: 0 15px 40px rgba(0, 191, 143, 0.3);">
      <h3 style="color: white; margin-bottom: 1rem; font-size: 1.5rem;">
        📸 Rivivi i Momenti del Consiglio
      </h3>
      <p style="font-size: 1.1rem; line-height: 1.8; margin-bottom: 2rem;">
        Scopri la galleria completa con le foto ufficiali dell'evento:<br>
        momenti salienti delle sessioni di lavoro, interventi dei relatori,<br>
        networking tra gli associati e foto di gruppo dei partecipanti.
      </p>
      <a href="/gallery/consiglio-napoli-2024" style="display: inline-block; background: white; color: #00bf8f; padding: 1rem 2.5rem; border-radius: 30px; text-decoration: none; font-weight: 700; font-size: 1.1rem; box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2); transition: all 0.3s; border: 2px solid white;">
        🖼️ Visualizza la Galleria Completa
      </a>
    </div>

    <h2>🎁 Offerta Speciale EUROCOC</h2>

    <div style="background: linear-gradient(135deg, rgba(251, 191, 36, 0.1) 0%, rgba(245, 158, 11, 0.05) 100%); border-left: 4px solid #f59e0b; padding: 2rem; border-radius: 12px; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <div style="text-align: center; margin-bottom: 1.5rem;">
        <img src="/images/logo-eurococ-2.svg" alt="Logo EUROCOC" style="max-width: 200px; height: auto; margin-bottom: 1.5rem;">
        <h3 style="color: #f59e0b; font-size: 1.5rem; margin-bottom: 0.5rem;">
          🎁 Buono Sconto di 15€
        </h3>
        <p style="font-size: 1.1rem; color: #92400e; margin-bottom: 0.5rem;">ad ogni studio di consulenza che ha partecipato</p>
        <p style="font-size: 1.1rem; color: #92400e; margin-bottom: 0.5rem;">al Consiglio Nazionale Studi</p>
        <h4 style="color: #f59e0b; font-size: 1.2rem; margin-top: 1rem;">sulla richiesta di un nuovo COC</h4>
      </div>
      <div style="background: rgba(251, 191, 36, 0.1); padding: 1rem; border-radius: 8px; margin-top: 1rem;">
        <p style="text-align: center; color: #92400e; font-weight: 600; margin: 0;">
          <i class="fas fa-info-circle"></i> Offerta riservata ai partecipanti del Consiglio Nazionale
        </p>
      </div>
    </div>

    <h2>👨‍👩‍👧‍👦 Visita Guidata per Familiari</h2>

    <div style="background: white; border-radius: 12px; padding: 2rem; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <p style="margin-bottom: 1rem;">È stata organizzata per i familiari che hanno accompagnato gli associati a Napoli una visita guidata durante i lavori associativi (il primo pomeriggio del 23/11 e la mattina del 24/11).</p>
      <p style="margin-bottom: 0;">Un'occasione per scoprire le bellezze di Napoli mentre si svolgevano le sessioni di lavoro del Consiglio.</p>
    </div>

    <h2>📧 Le Parole del Segretario Nazionale</h2>

    <div style="background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%); border-left: 4px solid #3b82f6; padding: 2rem; border-radius: 12px; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #2563eb; margin-bottom: 1.5rem;">
        <i class="fas fa-envelope"></i> Lettera del 18 novembre 2024
      </h3>
      <p style="font-style: italic; color: #1e40af; margin-bottom: 1rem;"><strong>Oggetto: Il Prossimo Consiglio Nazionale</strong></p>
      
      <p style="margin-bottom: 1rem;">Siamo ormai arrivati a ridosso dell'appuntamento col Consiglio Nazionale.</p>
      
      <p style="margin-bottom: 1rem;">Mi auguro di vedervi in tanti, le adesioni in questo momento ci indicano <strong>oltre duecento partecipanti</strong>, l'associazione è viva più che mai e questa ne è la dimostrazione.</p>
      
      <p style="margin-bottom: 1rem;">Il Consiglio Nazionale è il momento più alto della nostra attività, anche il più democratico, un momento di confronto indispensabile. La nostra è un'associazione vera, un unicum nel panorama Italiano, dove tutto viene sempre messo in discussione, perché tutti ragionano di sistema, lavorano per la collettività e si spendono per la causa, ognuno col proprio ruolo, tutti importanti allo stesso modo.</p>
      
      <p style="margin-bottom: 1rem;">In questo modo facciamo la differenza, in questo modo abbiamo affrontato i quasi sessant'anni della nostra storia. Oggi tanti giovani si stanno avvicinando alla nostra politica associativa, una grande soddisfazione, idee nuove, nuovi stimoli e nuove prospettive, il futuro è nelle nostre mani e sta a noi indirizzarlo nel verso giusto.</p>
      
      <p style="margin-bottom: 1rem;">Oggi come settore abbiamo un ruolo cruciale, le innumerevoli attività messe in campo ci portano a sederci nei tavoli che contano con autorevolezza e orgoglio. <strong>Siamo diventati il sistema</strong>, non dimentichiamocelo, ma non abbassiamo la guardia, i cambiamenti epocali che stiamo vivendo ci devono tenere sull'allerta per non rischiare di diventare un ricordo.</p>
      
      <p style="margin-bottom: 1rem;">L'appuntamento del 24 a Napoli sarà importantissimo, l'occasione per ascoltarvi, abbiamo voluto creare un evento per lasciare spazio sufficiente alle vostre idee, al vostro contributo, alle vostre considerazioni. Tutte cose che ci serviranno per prendere le giuste strade da percorrere nei prossimi tempi.</p>
      
      <p style="margin-bottom: 1rem;">L'ascolto e il confronto è la linfa vitale per fare i rappresentanti, perché questo siamo, i vostri rappresentanti, tutto il lavoro che quotidianamente svolgiamo lo facciamo su vostro mandato e con la vostra fiducia.</p>
      
      <p style="margin-bottom: 1rem;">Gli obbiettivi di una categoria sono comuni per tutti, le modalità per ottenerli sono, e devono essere, sempre in discussione.</p>
      
      <p style="margin-bottom: 1rem;">Vi aspetto dunque, con il solito piacere di rincontrarvi e stringervi la mano, una grande associazione è grande non solo per i suoi dirigenti, ma soprattutto per i suoi aderenti.</p>
      
      <p style="margin-bottom: 1rem;">Ci vediamo domenica 24 a Napoli.</p>
      
      <p style="margin-bottom: 1rem;">Un caro saluto.</p>
      
      <p style="text-align: right; font-weight: 600; color: #1e40af;">
        Il Segretario Nazionale Studi<br>
        Giuseppe Guarino
      </p>
    </div>

    <div style="background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%); border-left: 4px solid #10b981; padding: 2rem; border-radius: 12px; margin: 2rem 0; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #059669; margin-bottom: 1.5rem;">
        <i class="fas fa-envelope"></i> Lettera del 18 novembre 2024
      </h3>
      <p style="font-style: italic; color: #047857; margin-bottom: 1rem;"><strong>Oggetto: IL REGISTRO UNICO DEGLI STA È LEGGE</strong></p>
      
      <p style="margin-bottom: 1rem;"><strong>Ebbene sì, abbiamo il Registro Unico.</strong></p>
      
      <p style="margin-bottom: 1rem;">Oggi il Senato della Repubblica ha approvato definitivamente il DDL Sicurezza stradale e modifiche al Codice della Strada.</p>
      
      <p style="margin-bottom: 1rem;">Possiamo affermare che il relativo Articolo 6, dopo più di 30 anni dall'approvazione della legge 264, è il provvedimento più importante che ci riguardi.</p>
      
      <p style="margin-bottom: 1rem;">Un percorso lungo e accidentato quello dell'Articolo in questione, un percorso che abbiamo progettato, condiviso con i Ministeri interessati, e perfezionato tramite molteplici interlocuzioni con la politica.</p>
      
      <p style="margin-bottom: 1rem;">È stato un lavoro immenso per il quale abbiamo lavorato tutti, in primo luogo la Segreteria Nazionale che, insieme al Presidente ed al Responsabile della nautica, il 19 dicembre 2020 si è presentata al vostro voto con l'idea e la convinzione di dare vita ad un Albo professionale.</p>
      
      <p style="margin-bottom: 1rem;">Ma anche tutti coloro che collaborano con la nostra organizzazione, e parlo di tutti i componenti dei gruppi di lavoro impegnati giornalmente nel darci il supporto tecnico necessario. È la famosa Segreteria allargata di cui abbiamo sempre parlato, un valore immenso dal quale non si può prescindere.</p>
      
      <p style="margin-bottom: 1rem;">Ci sono anche tutti i Dirigenti, Regionali e Provinciali, quelli che hanno creduto nella nostra strategia politica e che ci hanno appoggiato nei territori.</p>
      
      <p style="text-align: center; font-size: 1.2rem; font-weight: 700; color: #047857; margin: 2rem 0;">
        Insomma un successo targato UNASCA.
      </p>
      
      <p style="margin-bottom: 1rem;">Domenica 24/11, al Consiglio Nazionale, parleremo diffusamente del percorso che questa legge dovrà fare, e per noi sarà un altro grande lavoro, ma sono sicuro che anche questa volta potremo contare su di voi.</p>
      
      <p style="margin-bottom: 1rem;"><strong>Grazie, dal profondo del cuore.</strong></p>
      
      <p style="text-align: right; font-weight: 600; color: #047857;">
        Il Segretario Nazionale Studi<br>
        Giuseppe Guarino
      </p>
    </div>

    <h2>🤝 I Nostri Sponsor</h2>

    <p style="margin-bottom: 2rem;">Un ringraziamento speciale ai nostri sponsor che hanno reso possibile questo evento:</p>

    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 2rem; padding: 2rem; background: white; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); margin-bottom: 2rem; align-items: center;">
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.dylog.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/dylog.PNG" alt="Dylog" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.egaf.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/egaf.PNG" alt="EGAF" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.eurococ.eu/it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/eurococ.PNG" alt="EUROCOC" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.cesareferrari.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/ferrari.PNG" alt="Cesare Ferrari" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.informaticafutura.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/futura.PNG" alt="Informatica Futura" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://microware.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/microware.PNG" alt="Microware" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.ptavant.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/ptavant.PNG" alt="PT Avant" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.gestionalepraticheauto.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/rs_2.PNG" alt="RS Gestionale" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.gestionalepraticheauto.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/rs.PNG" alt="RS" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.sermetra.it/il-consorzio-sermetra/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/sermetra.PNG" alt="Sermetra" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.sidadrive.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/sida.PNG" alt="Sida Drive" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://paperpixels.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/logo-paperpixels-text.svg" alt="PaperPixels" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://www.mooney.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/mooney.png" alt="Mooney" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
      <div style="text-align: center; padding: 1rem;">
        <a href="https://drive-easy.megasim.it/" target="_blank" rel="noopener noreferrer">
          <img src="/images/sponsor/optimized/logo-megasim-drive-easy.png" alt="Drive Easy" style="max-width: 150px; height: auto; filter: grayscale(20%); transition: all 0.3s;">
        </a>
      </div>
    </div>

    <div style="margin-top: 3rem; padding-top: 2rem; border-top: 2px solid #e2e8f0; text-align: center;">
      <p style="color: #4a5568; font-style: italic; font-size: 1.1rem;">
        Grazie a tutti i partecipanti per aver reso questo evento un successo straordinario!
      </p>
    </div>
  `,
  featuredImage: '/images/napoli-background.jpg',
  category: {
    id: 'eventi',
    name: 'Eventi',
    slug: 'eventi',
    color: '#8B5CF6'
  },
  tags: ['Consiglio Nazionale', 'Napoli 2024', 'Eventi', 'Registro STA', 'Rete Certificata'],
  author: {
    id: 'unasca-redazione',
    username: 'UNASCA',
    profile: {
      firstName: 'Redazione',
      lastName: 'UNASCA',
      fullName: 'Redazione UNASCA'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2024-11-24T10:00:00Z',
  createdAt: '2024-11-24T10:00:00Z',
  updatedAt: '2024-11-24T10:00:00Z',
  metadata: {
    views: 0,
    likeCount: 0,
    shares: 0
  },
  readingTime: 8
};

